import { TagView } from './tagView';

export default TagView;
import { TagView } from './tagView';

export default TagView;
